export const myTimesheetTranslationsHu = {
  MY_TIMESHEET_ADMIN_GUIDE: "MyTimesheet adminisztrátori kézikönyv",
  MY_TIMESHEET_VIEWER_GUIDE: "MyTimesheet megtekintői kézikönyv",
  MY_TIMESHEET_EXAMINER_GUIDE: "MyTimesheet elbírálói kézikönyv",
  MY_TIMESHEET_USER_GUIDE: "MyTimesheet felhasználói kézikönyv",
  MY_TIMESHEET_COST_VALUE_REQUIRED: "Költség megadása kötelező!",
  MY_TIMESHEET_DURATION_EXCEEDS_LIMIT: "Az időtartam meghaladja a maximálisan megadható 12 óra értéket!",
  MY_TIMESHEET_RECORDING_ACTIVITIES_NOT_ALLOWED: "Erre a napra tevékenység rögzítése nem megengedett!",
  MY_TIMESHEET_COST_UPDATE_FAILED: "A költség módosítása sikertelen",
  MY_TIMESHEET_COST_SUCCESSFUL_UPDATED: "A költség sikeresen módosítva",
  MY_TIMESHEET_NEW_COST_CREATE_FAILED: "Az új költség létrehozása sikertelen",
  MY_TIMESHEET_NEW_COST_SUCCESSFUL_CREATED: "Az új költség sikeresen létrehozva",
  MY_TIMESHEET_CLIENT_UPDATE_FAILED: "Az ügyfél módosítása sikertelen",
  MY_TIMESHEET_CLIENT_SUCCESSFUL_UPDATED: "Az ügyfél sikeresen módosítva",
  MY_TIMESHEET_NEW_CLIENT_CREATE_FAILED: "Az ügyfél létrehozása sikertelen",
  MY_TIMESHEET_NEW_CLIENT_SUCCESSFUL_CREATED: "Az ügyfél sikeresen létrehozva",
  MY_TIMESHEET_PROJECT_UPDATE_FAILED: "A projekt módosítása sikertelen",
  MY_TIMESHEET_PROJECT_SUCCESSFUL_UPDATED: "A projekt sikeresen módosítva",
  MY_TIMESHEET_DETAILS: "Leírás",
  MY_TIMESHEET_SELECT_COLOR: "Szín kiválasztása",
  MY_TIMESHEET_EDIT_COST: "Költség szerkesztése",
  MY_TIMESHEET_EDIT_CLIENT: "Ügyfél szerkesztése",
  MY_TIMESHEET_EDIT_PROJECT: "Projekt szerkesztése",
  MY_TIMESHEET_NEW_CLIENT: "Új ügyfél",
  MY_TIMESHEET_CLIENT_NAME: "Ügyfél megnevezése",
  MY_TIMESHEET_COST_NAME: "Költség megnevezése",
  MY_TIMESHEET_NEW_COST: "Új költség",
  MY_TIMESHEET_BILLABLE_COST: "Számlázható",
  MY_TIMESHEET_SAVE_NEW_PROJECT_TEXT: "Dolgozó felvehet új projektet, amennyiben nincs olyan projekt a listában, amelyet használni szeretne.",
  MY_TIMESHEET_SAVE_NEW_PROJECT: "Új projekt rögzítése",
  MY_TIMESHEET_NO_WORKING_TIME_REPORT_DATA: "A megadott időben nincs rögzített munkaidő!",
  MY_TIMESHEET_EXAMINER_VIEW: "Elbírálói",
  MY_TIMESHEET_VIEWER_VIEW: "Megtekintői",
  MY_TIMESHEET_SUCCESSFUL_REJECTED: "Az időbejegyzés sikeresen elutasítva!",
  MY_TIMESHEET_REJECT_FAILED: "Az időbejegyzés elutasítása sikertelen!",
  MY_TIMESHEET_MONDAY: "Hétfő",
  MY_TIMESHEET_TUESDAY: "Kedd",
  MY_TIMESHEET_WEDNESDAY: "Szerda",
  MY_TIMESHEET_THURSDAY: "Csütörtök",
  MY_TIMESHEET_FRIDAY: "Péntek",
  MY_TIMESHEET_SATURDAY: "Szombat",
  MY_TIMESHEET_SUNDAY: "Vasárnap",
  MY_TIMESHEET_WEEK: "hét",
  MY_TIMESHEET_WORKTIME_REPORT: "Munkaidő kimutatás",
  MY_TIMESHEET_WORKTIME_SUMMARY: "Munkaidő összegzés",
  MY_TIMESHEET_OWN_WORKIME: "Saját munkaidő",
  MY_TIMESHEET_REQUESTED_DURATION: "Kérelmezett időtartam",
  MY_TIMESHEET_REQUESTED_COST: "Kérelmezett költség",
  MY_TIMESHEET_REQUESTS: "MyTimesheet kérelmek",
  MY_TIMESHEET_REVOKE_REQUEST: "Kérelmem visszavonása",
  MY_TIMESHEET_DESCRIPTION_TOO_LONG: "A megjegyzés túl hosszú!",
  MY_TIMESHEET_NAME_TOO_LONG: "A név túl hosszú!",
  MY_TIMESHEET_NAME_ALREADY_EXISTS: "Ez a név már használatban van",
  MY_TIMESHEET_NEW_PROJECT_CREATE_FAILED: "A projekt létrehozása sikertelen",
  MY_TIMESHEET_NEW_PROJECT_SUCCESSFUL_CREATED: "A projekt sikeresen létrehozva",
  MY_TIMESHEET_PROJECT_NAME: "Projekt megnevezése",
  MY_TIMESHEET_NEW_PROJECT: "Új projekt",
  MY_TIMESHEET_UPDATE_FAILED: "Az időbejegyzés módosítása sikertelen!",
  MY_TIMESHEET_SUCCESSFUL_UPDATED: "Az időbejegyzés sikeresen módosítva",
  MY_TIMESHEET_CREATE_FAILED: "Az időbejegyzés létrehozása sikertelen!",
  MY_TIMESHEET_SUCCESSFUL_CREATED: "Az időbejegyzés sikeresen létrehozva",
  MY_TIMESHEET_REMOVAL_FAILED: "Az időbejegyzés visszavonása sikertelen!",
  MY_TIMESHEET_SUCCESSFUL_REMOVED: "Az időbejegyzés sikeresen visszavonva",
  MY_TIMESHEET_MINUTE: "Perc",
  MY_TIMESHEET_SUMMARY: "Munkaidő kimutatás",
  MY_TIMESHEET_COST_SUMMARY: "Költség kimutatás",
  MY_TIMESHEET_CLIENT_SUMMARY: "Ügyfél kimutatás",
  MY_TIMESHEET_PROJECT_SUMMARY: "Projekt kimutatás",
  MY_TIMESHEET_TOTAL_COST: "Összes költség",
  MY_TIMESHEET_TOTAL_TIME_BILLABLE: "Összes idő (számlázható)",
  MY_TIMESHEET_TOTAL_TIME: "Összes idő",
  MY_TIMESHEET_CREATE: "Létrehoz",
  MY_TIMESHEET_SEND_APPROVAL: "Küldés elbírálásra",
  MY_TIMESHEET_EDIT_ACTIVITY: "Időbejegyzés szerkesztése",
  MY_TIMESHEET_WORKTIME: "Munkaidő",
  MY_TIMESHEET_ADD_NEW_PROJECT: "Új projekt hozzáadása",
  MY_TIMESHEET_ACTIVITY_REQUEST: "Időbejegyzés kérelem",
  MY_TIMESHEET_WEEK_TOTAL: "Heti összesen",
  MY_TIMESHEET_NEW_ACTIVITY: "Új időbejegyzés",
  MY_TIMESHEET_ACTIVITIES: "Tevékenységek",
  MY_TIMESHEET_ACTIVITY_RECORD: "Időbejegyzés rögzítés",
  MY_TIMESHEET_END_OF_WORK: "Munka vége",
  MY_TIMESHEET_DAILY_TOTAL: "Napi összesen",
  MY_TIMESHEET_CLOCK_IN: "Munka kezdete",
  MY_TIMESHEET_THIS_WEEK: "Ez a hét",
  MY_TIMESHEET_LAST_WEEK: "Múlt hét",
  MY_TIMESHEET_ADD_TIMESHEET: "Új időbejegyzés",
  MY_TIMESHEET_WORK_TIME_DASHBOARD_WEEKLY: "Munkaidő heti kimutatás",
  MY_TIMESHEET_DURATION: "Időtartam",
  MY_TIMESHEET_CLIENT: "Ügyfél",
  MY_TIMESHEET_SUMMARY_STATEMENT: "Kimutatás",
  MY_TIMESHEET_PROJECT: "Projekt",
  MY_TIMESHEET_TOTAL_WORK_HOURS_TODAY: "Összes munkaóra ma",
  MY_TIMESHEET_TIMESHEET: "Munkaidő kimutatás",
  MY_TIMESHEET_TIME_TRACKER: "Időkövető",
  MY_TIMESHEET_MONTHLY: "Havi",
  MY_TIMESHEET_WEEKLY: "Heti",
  MY_TIMESHEET_TIMESHEET_REPORT: "Teljesítés igazolás",
  MY_TIMESHEET_DAILY_BREAKDOWN: "Napi bontás",
  MY_TIMESHEET_ACTIVITY: "Tevékenység",
  MY_TIMESHEET_START: "Kezdés",
  MY_TIMESHEET_END: "Befejezés",
  MY_TIMESHEET_BREAKDOWN: "Bontás",
  MY_TIMESHEET_EMPLOYEE_SIGNATURE: "Foglalkoztatott aláírása",
  MY_TIMESHEET_MANAGER_SIGNATURE: "Vezető aláírása",
  MY_TIMESHEET_TIMESHEET_REPORT_PRINT: "Kimutatás nyomtatás",
  MY_TIMESHEET_TOTAL_DURATION: "Összes időtartam",
  MY_TIMESHEET_PERFORMER_SIGNATURE: "Tevékenységet végző",
  MY_TIMESHEET_CERTIFIER_SIGNATURE: "Teljesítés igazoló",
}
